var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "mb-3", attrs: { outlined: "", loading: _vm.loading } },
        [
          _c("v-card-text", { staticClass: "text-center" }, [
            _c("div", { staticClass: "text-subtitle-2 grey--text" }, [
              _vm._v(_vm._s(_vm.$t("message.flex.balance"))),
            ]),
            _c(
              "div",
              { staticClass: "text-h4 my-2", class: _vm.balanceColor },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$formatter.formatFlexMinutes(
                        _vm.balance.balance_minutes
                      )
                    ) +
                    " "
                ),
              ]
            ),
            _vm.balance.policy_name
              ? _c("div", { staticClass: "text-caption grey--text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.flex.policy")) +
                      ": " +
                      _vm._s(_vm.balance.policy_name) +
                      " "
                  ),
                ])
              : _vm._e(),
            _vm.balance.as_of
              ? _c("div", { staticClass: "text-caption grey--text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.flex.asOf")) +
                      ": " +
                      _vm._s(
                        _vm.$formatter.formatDate(
                          _vm.balance.as_of,
                          "",
                          "DD.MM.YYYY HH:mm"
                        )
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { outlined: "" } },
        [
          _c("v-card-title", { staticClass: "text-subtitle-1" }, [
            _vm._v(_vm._s(_vm.$t("message.flex.transactions"))),
          ]),
          _c("v-divider"),
          _vm.recentTransactions.length
            ? _c(
                "v-list",
                { attrs: { "two-line": "", dense: "" } },
                _vm._l(_vm.recentTransactions, function (tx) {
                  return _c(
                    "v-list-item",
                    { key: tx.id },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(_vm.txTypeLabel(tx.type))),
                          ]),
                          _c("v-list-item-subtitle", [
                            _vm._v(
                              _vm._s(
                                _vm.$formatter.formatDate(
                                  tx.date,
                                  "YYYY-MM-DD",
                                  "DD.MM.YYYY"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("v-list-item-action", [
                        _c(
                          "span",
                          {
                            class:
                              tx.delta_minutes >= 0
                                ? "success--text"
                                : "error--text",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$formatter.formatFlexMinutes(
                                    tx.delta_minutes
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                1
              )
            : _c("v-card-text", { staticClass: "grey--text" }, [
                _vm._v(_vm._s(_vm.$t("message.flex.noTransactions"))),
              ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    color: "primary",
                    to: { name: "flex-transactions" },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.flex.transactionHistory")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }